<h2>Импорт прайса</h2>
<form class="drop-padding" (ngSubmit)="upload()" [formGroup]="formGroup">
  <div class="left-wrapper">
    <input #file_input class="file_input" type="file" (change)="onFileSelected($event)" />
    <app-provider-selector [control]="providerControl" [disabled]="loading"></app-provider-selector>
    <mat-form-field appearance="outline">
      <mat-label>Колонка названия</mat-label>
      <input
        matInput
        type="text"
        placeholder="Колонка названия"
        formControlName="description_column"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Колонка артикула</mat-label>
      <input matInput type="text" placeholder="Колонка артикула" formControlName="article_column" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Колонка производителя</mat-label>
      <input
        matInput
        type="text"
        placeholder="Колонка производителя"
        formControlName="brand_column"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Колонка цены</mat-label>
      <input matInput type="text" placeholder="Колонка цены" formControlName="price_column" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Разделитель</mat-label>
      <input matInput type="text" placeholder="Разделитель" formControlName="delimiter" />
    </mat-form-field>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="file_input.click()"
      [disabled]="loading"
    >
      {{ selectedFile ? selectedFile.name : 'Выбарть файл' }}
    </button>
    <button mat-flat-button color="primary" type="submit" [disabled]="loading">
      {{ loading ? 'Загрузка' : 'Загрузить' }}
    </button>
  </div>
  <div class="right-wrapper">
    <ng-container formArrayName="wh_array">
      <ng-container *ngFor="let wh of whArray.controls; let i = index">
        <div [formGroupName]="i">
          <mat-form-field appearance="outline">
            <mat-label>{{ wh.value.wh.description }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="column"
              [placeholder]="wh.value.wh.description"
            />
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
  </div>
</form>
